export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function extractUnit(fullUnit: string) {
  const match = fullUnit.match(/\(([^)]+)\)/);
  return match ? match[1] : fullUnit;
}

export function nowISOString(): string {
  return new Date().toISOString();
}

export function yesterdayISOString(): string {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return date.toISOString();
}

export function lastMonthISOString(): string {
  const date = new Date();
  date.setDate(date.getDate() - 30);
  date.setHours(0, 0, 0, 0);
  return date.toISOString();
}

export function twoMonthsAgoISOString(): string {
  const date = new Date();
  date.setDate(date.getDate() - 60);
  date.setHours(0, 0, 0, 0);
  return date.toISOString();
}

export function subtractMinutes(minutes: string): string {
  const now = new Date();
  return new Date(now.getTime() - (Number(minutes) * 60000)).toISOString();
}

export const DESC_MAP: Record<string, string> = {
  PM1:  'Particulates (1 μm)',
  PM4:  'Particulates (4 μm)',
  PM10: 'Particulates (10 μm)',
  PM25: 'Particulates (2.5 μm)',
  CC1:  'Phase 1 Current (mA)',
  CC2:  'Phase 2 Current (mA)',
  CC3:  'Phase 3 Current (mA)',
  TMP2: 'Temperature Ext. Probe (°C)',
  TMP5: 'Temperature (°C)',
  HUM2: 'Humidity (%)',
  CNT1: 'Pulse Channel 1 (Gas/Water)',
  CNT2: 'Pulse Channel 2 (Gas/Water)',
  LGHT: 'Light (Lux)',
  SND:  'Sound (dB)',
  NOX:  'Nitrogen Oxide Index',
  VOC:  'Volatile Compound Index',
  ZRV1: 'Z-Axis RMS Velocity (mm/sec)',
  XRV1: 'X-Axis RMS Velocity (mm/sec)',
  ZPV1: 'Z-Axis Peak Velocity (mm/sec)',
  XPV1: 'X-Axis Peak Velocity (mm/sec)',
  Imp:  'Imported kWh (Main Incomer)',
  VP1:  'Voltage Phase 1 (Main Incomer)',
  VP2:  'Voltage Phase 2 (Main Incomer)',
  VP3:  'Voltage Phase 3 (Main Incomer)',
  AP1:  'Ampere Phase 1 (Main Incomer)',
  AP2:  'Ampere Phase 2 (Main Incomer)',
  AP3:  'Ampere Phase 3 (Main Incomer)',
  PF:   'Power Factor (Main Incomer)',
};

